import React, { Component } from 'react'
import './size-indicator.css'

class SizeHolder extends Component {

    render() {
        return (
            <div className="size-holder">
                {this.props.children}
            </div>
        )
    }
}

export default SizeHolder